import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

import Button from "@material-ui/core/Button";
import FilterIcon from "@material-ui/icons/PermContactCalendar";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import RootRef from "@material-ui/core/RootRef";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core";

import * as a from "./action";
import { compose } from "ramda";

const DATE_REGEX = /\d{1,2}\/\d{1,2}\/\d{4}/;
const DATE_FORMAT = "MM/DD/YYYY";

const panelStyles = theme => ({
  valid: {},
  invalid: {
    boxShadow: "0 0 1px red"
  },
  root: {
    display: "flex",
    flexDirection: "column",
    transition: "boxShadow .6s",
    padding: `1rem`,
    position: "absolute",
    zIndex: 300000,
    "& > *": {
      "margin": ".2rem 0"
    }
  }
});

const PaperValidation = withStyles(panelStyles)(
  ({ classes: { valid, invalid, ...classes }, valid: isValid, ...props }) => (
    <Paper
      elevation={isValid ? 4 : 1}
      className={classNames({
        [valid]: isValid,
        [invalid]: !isValid
      })}
      classes={classes}
      {...props}
    />
  )
);

const componentTransformer = compose(
  connect(
    _ => ({}),
    dispatch => bindActionCreators({ ...a }, dispatch)
  )
);

class Popover extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();

    this.state = {
      after: "",
      before: ""
    };
  }

  componentDidUpdate() {
    if (!!this.ref.current) {
      const { width: panelWidth } = this.ref.current.getBoundingClientRect();
      const { width: buttonWidth } = this.props.anchorEl.getBoundingClientRect();

      // NOTE: I guess this solution makes sense... I don't like it though.
      this.ref.current.style.transform = `translate(-${panelWidth - buttonWidth * 2}px, 0)`;
    }

    this.debouncedOnDateUpdate();
  }

  debouncedOnDateUpdate() {
    if (this.debounceHandle) {
      clearTimeout(this.debounceHandle);
      this.debounceHandle = null;
    }
    this.debounceHandle = setTimeout(() => {
      if (this.validDateRange && typeof this.props.onDateUpdate === "function") {
        this.props.onDateUpdate({
          after: this.state.after,
          before: this.state.before
        });
      }
    }, 1500);
  }

  get validDateRange() {
    const { after: afterString, before: beforeString } = this.state;

    try {
      const after = moment(afterString, DATE_FORMAT);
      const before = moment(beforeString, DATE_FORMAT);

      return (
        after.isValid() &&
        before.isValid() &&
        after <= before &&
        DATE_REGEX.test(afterString) && 
        DATE_REGEX.test(beforeString)
      );
    } catch (error) {
      return false;
    }
  }

  get sampleAfter() {
    return moment()
      .subtract(1, "months")
      .format(DATE_FORMAT);
  }

  get sampleBefore() {
    return moment().format(DATE_FORMAT);
  }

  render() {
    if (!this.props.anchorEl) return null;

    return (
      <RootRef rootRef={this.ref}>
        <PaperValidation valid={this.validDateRange}>
          <Typography>Date Range</Typography>
          <Tooltip
            title="Double Click to set a month ago."
            enterDelay={1000}
          >
            <TextField
              label="Start"
              value={this.state.after}
              placeholder={this.sampleAfter}
              onChange={this.changeHandler("after")}
              onDoubleClick={this.doubleClickHandler("after")}
            />
          </Tooltip>
          <Tooltip
            title="Double Click to set a today."
            enterDelay={1000}
          >
            <TextField
              label="End"
              value={this.state.before}
              placeholder={this.sampleBefore}
              onChange={this.changeHandler("before")}
              onDoubleClick={this.doubleClickHandler("before")}
            />
          </Tooltip>
          <Button onClick={this.clickHandler}>clear</Button>
        </PaperValidation>
      </RootRef>
    );
  }

  updateDate = (name, text) => {
    this.setState({ [name]: text });
  };

  changeHandler = name => event => {
    this.updateDate(name, event.target.value);
  };

  doubleClickHandler = name => event => {
    if (this.state[name] !== "") return;

    switch (name) {
      case "after":
        this.updateDate(name, this.sampleAfter);
        break;
      case "before":
        this.updateDate(name, this.sampleBefore);
        break;
      default:
        throw new Error("Unhandled double click event.");
    }
  };

  clickHandler = event => {
    this.setState({ after: "", before: "" });
    this.props.onClear();
  };
}

Popover = withStyles(panelStyles)(Popover);

class Panel extends Component {
  static displayName = "DateFilterPanel";

  constructor(props) {
    super(props);
    this.ref = React.createRef();

    this.state = {
      anchorEl: null
    };
  }

  componentWillUnmount() {
    this.props.clearFilter();
  }

  get isOpen() {
    return !!this.state.anchorEl;
  }

  get title() {
    return this.isOpen ? "Close Date Filter" : "Open Date Filter";
  }

  render() {
    return (
      <div>
        <Tooltip title={this.title} placement="top">
          <IconButton onClick={this.clickHandler}>
            <FilterIcon />
          </IconButton>
        </Tooltip>
        <Popover
          onClear={this.props.clearFilter}
          anchorEl={this.state.anchorEl}
          onDateUpdate={this.props.updateDateRange} />
      </div>
    );
  }

  clickHandler = event => {
    if (this.state.anchorEl) {
      this.setState({ anchorEl: null });
    } else {
      this.setState({ anchorEl: event.target });
    }
  };
}

Panel = componentTransformer(Panel);

export { Panel };
